<template>
  <PopoverTrigger v-if="isTouchPointer" v-bind="props">
    <slot />
  </PopoverTrigger>
  <TooltipTrigger v-else v-bind="props">
    <slot />
  </TooltipTrigger>
</template>

<script setup lang="ts">
import { PopoverTrigger, TooltipTrigger, type TooltipTriggerProps } from "reka-ui"
import { useMediaQuery } from "@vueuse/core"

const props = defineProps<TooltipTriggerProps>()

const isTouchPointer = useMediaQuery("(hover: none) and (pointer: coarse)")
</script>
